import { NavLink, Outlet, Navigate } from "react-router-dom";
import { useIsAdmin } from "@/hooks/useIsAdmin";
import { Skeleton } from "@/components/ui/skeleton";
import { Users, CreditCard, Palette, Shield, Building2, Banknote, Search } from "lucide-react";

const tabs = [
  { to: "/admin", label: "Users", icon: Users, end: true },
  { to: "/admin/plans", label: "Plans", icon: CreditCard },
  { to: "/admin/payments", label: "Payments", icon: Banknote },
  { to: "/admin/bank-settings", label: "Bank Settings", icon: Building2 },
  { to: "/admin/brand", label: "Brand", icon: Palette },
  { to: "/admin/seo", label: "SEO", icon: Search },
];

export default function AdminLayout() {
  const { isAdmin, loading } = useIsAdmin();
  if (loading) return <Skeleton className="h-64 w-full" />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;

  return (
    <div className="space-y-6 max-w-7xl mx-auto">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-lg bg-gradient-primary flex items-center justify-center shadow-glow">
          <Shield className="h-5 w-5 text-primary-foreground" />
        </div>
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Admin</h1>
          <p className="text-muted-foreground text-sm">
            Manage users, plans and platform brand.
          </p>
        </div>
      </div>

      <div className="border-b flex gap-1 overflow-x-auto">
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              `flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors -mb-px ${
                isActive
                  ? "border-primary text-foreground"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              }`
            }
          >
            <t.icon className="h-4 w-4" />
            {t.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
}
